module.exports = __webpack_public_path__ + "media/loopingheader-final.c919f1df.mp4";